import {
  ROW,
  TEXTBOX,
  VERTICALSPACER,
  STANDARDPRODUCTTABLE,
  ABOUT,
  ABTESTWRAPPER,
  APPROW,
  AUDIOEMBED,
  ARTICLEHEROWRAPPER,
  AUTOINSURANCEENTRYPOINTWRAPPER,
  AUTOINSURANCEQUOTESWRAPPER,
  AWARDSBADGEDROPDOWN,
  AWARDSHERO,
  AWARDSHERO2023,
  AWARDSNAVIGATION,
  AWARDTABLE,
  BACKTOTOP,
  BOXTABLE,
  BORDERBANNER,
  BRANDHEADER,
  BRANDEDARTICLECALCULATOR,
  BRANDEDHERO,
  BULLETEDLIST,
  C3CHART,
  CALCULATOR,
  CATEGORYTILES,
  CDSPRODUCTTABLE,
  CDSFILTERS,
  CENTEREDHERO,
  CHARTSECTION,
  COLLAPSIBLEPARAGRAPH,
  CREDITCARDTABLE,
  CTABOX,
  DISCLOSURE,
  DIVIDER,
  EDITABLEBULLETEDLIST,
  EDITABLEFLYOUTHEADER,
  EDITABLEFLOW,
  EDITABLEINTERESTCALCULATOR,
  EDITABLELOGOSALAD,
  EDITABLEPANELGROUP,
  EDITABLEPRODUCTTABLE,
  EDITORCONTROL,
  EXPANDINGPRODUCTTABLE,
  FEATUREBAR,
  FEATUREDSTORY,
  FILTERS,
  FLEXCARD,
  GLOBALNAV,
  GRIDFORM,
  HEROLANDSCAPEVIDEO,
  HEROVIDEO,
  HOMEINSURANCEENTRYPOINTWRAPPER,
  ICONHEADER,
  IMAGE,
  IMAGECONTENT,
  INSURANCEPRODUCTCARDWRAPPER,
  INSURANCESTICKYWIDGET,
  JUMPLINKNAV,
  LABELEDC3CHART,
  LASTCHANCE,
  LASTUPDATE,
  LIFEINSURANCEQUOTESWRAPPER,
  MARKETPLACEPRODUCTCARD,
  MARKETPLACETHIRDPARTYEMBED,
  NPSCRMEMAIL,
  PAGE,
  PARAGRAPH,
  PASSWORDLOCK,
  OURVALUES,
  QUERYPARAMMANAGER,
  QUERYPARAMSECTION,
  RENTERSINSURANCEENTRYPOINTWRAPPER,
  ROWTWOCOL,
  ROWTWOCOLOLD,
  SCREENSIZECONDITIONAL,
  SCROLLCONTROL,
  SPLASH,
  STANDARDHERO,
  STICKYCONTAINERWRAPPER,
  STICKYHEADER,
  STORY,
  STORYBLOCK,
  STORYCARDS,
  INSURANCESUMMARYTABLEWRAPPER,
  TERMSTABLE,
  THREESTEPS,
  THREESTEPS2,
  TILECAROUSEL,
  UNIVERSALPRODUCTTABLE,
  VIDEOEMBED,
  ZIGZAG,
} from './types';
import { NW_SCHEMAS } from './utils';

/**
 * Schema definitions for landing page client components.
 */
const LPC_SCHEMAS = {
  [ROW]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [TEXTBOX]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [VERTICALSPACER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STANDARDPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ABOUT]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ABTESTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [APPROW]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AUDIOEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ARTICLEHEROWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AUTOINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AUTOINSURANCEQUOTESWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSBADGEDROPDOWN]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSHERO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSHERO2023]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSNAVIGATION]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BACKTOTOP]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BOXTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BORDERBANNER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDHEADER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDEDARTICLECALCULATOR]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BRANDEDHERO]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BULLETEDLIST]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [C3CHART]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CALCULATOR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CATEGORYTILES]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CDSPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CDSFILTERS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CENTEREDHERO]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [CHARTSECTION]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [COLLAPSIBLEPARAGRAPH]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [CREDITCARDTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [CTABOX]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [DISCLOSURE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [DIVIDER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEBULLETEDLIST]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEFLOW]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEINTERESTCALCULATOR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEFLYOUTHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLELOGOSALAD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEPANELGROUP]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITABLEPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [EDITORCONTROL]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [EXPANDINGPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FEATUREBAR]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FEATUREDSTORY]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FILTERS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [FLEXCARD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [GLOBALNAV]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [GRIDFORM]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HEROLANDSCAPEVIDEO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HEROVIDEO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [HOMEINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ICONHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [IMAGE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [IMAGECONTENT]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCEPRODUCTCARDWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCESTICKYWIDGET]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCESUMMARYTABLEWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [JUMPLINKNAV]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LABELEDC3CHART]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LASTCHANCE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LASTUPDATE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [LIFEINSURANCEQUOTESWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [MARKETPLACEPRODUCTCARD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [MARKETPLACETHIRDPARTYEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [NPSCRMEMAIL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [PAGE]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [PARAGRAPH]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [PASSWORDLOCK]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [QUERYPARAMMANAGER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [OURVALUES]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [QUERYPARAMSECTION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [RENTERSINSURANCEENTRYPOINTWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ROWTWOCOL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ROWTWOCOLOLD]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [SCREENSIZECONDITIONAL]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [SCROLLCONTROL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [SPLASH]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STANDARDHERO]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYCONTAINERWRAPPER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYHEADER]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STORY]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [STORYBLOCK]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [STORYCARDS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TERMSTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [THREESTEPS]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [THREESTEPS2]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [TILECAROUSEL]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALPRODUCTTABLE]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [VIDEOEMBED]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
  [ZIGZAG]: {
    nodeProps: [],
    version: '1.0.0',
    migrations: {},
  },
};

/**
 * Include default Structured Content schema so we can interpret documents that contain generic NW components.
 */
export default {
  ...NW_SCHEMAS,
  ...LPC_SCHEMAS,
};
